// ADR-0015: the counts exactly as the engine reported them; an option nobody chose shows 0.
const LIKERT_RATINGS = ['5', '4', '3', '2', '1'];

export interface AnswerRow {
  rating: string;
  count: number;
  pct: number;
}

export interface AnswerDistribution {
  rows: AnswerRow[];
  total: number;
  top2Pct: number;
}

export const answerDistribution = (distribution?: Record<string, number>): AnswerDistribution => {
  const dist = distribution ?? {};
  const countOf = (rating: string) => dist[rating] ?? 0;
  const extra = Object.keys(dist).filter((r) => !LIKERT_RATINGS.includes(r) && countOf(r) > 0);
  const ratings = [...LIKERT_RATINGS, ...extra].sort((a, b) => Number(b) - Number(a));
  const total = ratings.reduce((sum, r) => sum + countOf(r), 0);
  const pct = (count: number) => (total > 0 ? Math.round((count / total) * 100) : 0);
  const rows = ratings.map((rating) => ({
    rating,
    count: countOf(rating),
    pct: pct(countOf(rating)),
  }));
  return { rows, total, top2Pct: pct(countOf('5') + countOf('4')) };
};
